import { isNil } from '@lucidlink/tscore';
import { concatArrays, stringToArray } from './binary-utils';
import { cryptoKeyToArray } from './crypto-binary-utils';
export const webCryptoTupleToArray = async (tuple) => {
    const isCryptoKey = (value) => {
        const valueType = Object.prototype.toString.call(value);
        return !isNil(value) && valueType == '[object CryptoKey]';
    };
    const isArrayBuffer = (value) => {
        const valueType = Object.prototype.toString.call(value);
        return !isNil(value) && valueType == '[object ArrayBuffer]';
    };
    const arrays = [];
    for (const element of tuple) {
        if (isCryptoKey(element)) {
            arrays.push(await cryptoKeyToArray(element));
        }
        else if (isArrayBuffer(element)) {
            arrays.push(element);
        }
        else {
            arrays.push(stringToArray(element));
        }
    }
    return concatArrays(arrays);
};
